import { useCallback, useMemo } from 'react';

import { SuccessProps } from './success.types';
import { useModalsContext } from '../../../../../../contexts';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

/**
 * useSuccessData hook
 * @description The hook which processes ClosePortfolio flow Success data
 *
 * @author Oleksii Medvediev
 * @category Hooks
 */
const useSuccessData = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });
  const {
    data: { closePortfolioSuccess },
  } = useModalsContext();
  const navigate = useNavigate();

  const flowData: SuccessProps | undefined = useMemo(() => closePortfolioSuccess, [closePortfolioSuccess]);

  const handleSubmitSuccess = useCallback(() => {
    flowData && flowData.onSubmitSuccess();
    navigate(`/management/information/account/information?accountId=${flowData?.accountId}`);
  }, [flowData, navigate]);

  return {
    t,
    flowData,
    handleSubmitSuccess,
  };
};

export { useSuccessData };
